import React from 'react'

const TemplateGroupTile = ({ group, questionIds, answered, onSetActiveGroupId, onClick, activeGroupId }) => {
    const handleClick = () => {
        onSetActiveGroupId(group.groupId)
        // onClick(group.id)
    }

    let percentage = 0
    if (questionIds.length > 0) {
        percentage = answered.filter(ans => ans._computed.statusValue === 'SUBMITTED' || ans._computed.statusValue === 'APPROVED').length / questionIds.length * 100
    }
    const answerError = answered?.find(answer => answer._computed.statusValue === 'REJECTED')

    return (
        <div className={`template-group-tile ${answerError ? 'error' : ''} ${activeGroupId === group.groupId ? 'selected' : ''}`} onClick={handleClick}>
            <div className="title-wrapper">
                <span className="title">{group.groupTitle}</span>
            </div>
            <div className="answer-progress">
                <div className="progress" style={{ width: `${percentage > 100 ? 100 : percentage}%` }} />
            </div>
            <div className="progress-status">
                { percentage === 0
                    ? <span>Not started</span>
                    : <span>{answered.length} of {questionIds.length} answered</span>
                }
                { answerError && <span className="error"> - Attention needed</span>
                }
            </div>
        </div>
    )
}

export default TemplateGroupTile
